import { Action } from '@ngrx/store';
import { DynamicDns } from '../models/dynamic-dns.model';

export enum ActionTypes {
  SET_DYNAMIC_DNS_CONFIGURATION = 'SET_DYNAMIC_DNS_CONFIGURATION',
  UPDATE_DYNAMIC_DNS_CONFIGURATION = 'UPDATE_DYNAMIC_DNS_CONFIGURATION',
  RESET_DYNAMIC_DNS_CONFIGURATION = 'RESET_DYNAMIC_DNS_CONFIGURATION',
}

export class SetDynamicDnsConfiguration implements Action {
  readonly type = ActionTypes.SET_DYNAMIC_DNS_CONFIGURATION;
  constructor(public payload: DynamicDns) {}
}

export class UpdateDynamicDnsConfiguration implements Action {
  readonly type = ActionTypes.UPDATE_DYNAMIC_DNS_CONFIGURATION;
  constructor(public payload: DynamicDns) {}
}

export class ResetDynamicDnsConfiguration implements Action {
  readonly type = ActionTypes.RESET_DYNAMIC_DNS_CONFIGURATION;
}

export type Actions =
  | SetDynamicDnsConfiguration
  | UpdateDynamicDnsConfiguration
  | ResetDynamicDnsConfiguration;
